<template>
    <div>
        <b-form-group label="Latitud" label-for="latitude">
            <b-form-input v-model="latitude" placeholder="Latitud" :disabled="disabled"
                          :class="validation ? 'is-invalid': ''"/>
            <small v-if="validation" class="text-danger">
                {{ validation }}</small>
        </b-form-group>
    </div>
</template>

<script>
import {BFormGroup, BFormInput} from 'bootstrap-vue'

export default {
    components: {
        BFormGroup,
        BFormInput,
    },
    props: {
        latitude: {
            type: String,
            default: ''
        },
        validation: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            localLatitudeInput: this.latitude,
        }
    },
    watch: {
        latitude(newVal) {
            this.localLatitudeInput = newVal
            this.$emit('update', { latitude: this.localLatitudeInput })
        },
    },
}
</script>
